import React from 'react';
import mapboxgl from 'mapbox-gl';
import { KuPhilippinesMap } from './coordinates/KuPhilippines';
import { KuIndonesiaMap } from './coordinates/KuIndonesia';
import { KuIndiaMap } from './coordinates/KuIndia';
import { KuBDMap } from './coordinates/KuBD';
import { KuCMap } from './coordinates/KuC';
import { clearMap } from '../helpers/MapboxHelper';
import { satelliteBase64 } from './satelliteBase64';
import math from 'mathjs';
import './Map.css';

// mapboxgl.accessToken = 'pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4M29iazA2Z2gycXA4N2pmbDZmangifQ.-g_vE53SD2WrJ6tFX7QHmA';
mapboxgl.accessToken = 'pk.eyJ1IjoiYXV0b21jaGRldiIsImEiOiJjanc0eWc5Y2EwbDI2NDRtcndqb2lkeGE1In0.L7FGiJbgYInwe35ZVzbJtQ';
class Map extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      map: '',
      previousBand: '',
      pop: ''
    }
    this.props = props;
    this.PI = math.pi
    this.abs = math.abs
    this.sqrt = math.sqrt
    this.sin = math.sin
    this.cos = math.cos
    this.asin = math.asin
    this.acos = math.acos
    this.atan = math.atan
    this.pow = math.pow

    this.satelliteLng = 119.1;
    this.altitude = 0;
    this.r_e = 6378.14;
    this.r_s = 42164.17;
    this.hgso = this.r_s - this.r_e;
    this.e_e = 0.08182;
    this.getMap = { 
      'CBand': KuCMap,
      'BDBand': KuBDMap,
      'IndoBand': KuIndonesiaMap,
      'IndiaBand': KuIndiaMap,
      'PhBand': KuPhilippinesMap
    }
  }

  componentWillReceiveProps(nextProps) {
    let map = this.state.map;
    let previousBand = this.state.previousBand;
    if (nextProps.band === previousBand){
      return
    }
    map = clearMap(map, previousBand);
    map = map.jumpTo({ 'center': nextProps.center, 'zoom': 2 });

    map = this.getMap[nextProps.band](map);

    map.addLayer({
      "id": "points",
      "type": "symbol",
      "source": {
        "type": "geojson",
        "data": {
          "type": "FeatureCollection",
          "features": [{
            "type": "Feature",
            "geometry": {
              "type": "Point",
              "coordinates": [119.1, 0]
            }
          }]
        }
      },
      "layout": {
        "icon-image": "satellite",
        "icon-size": 0.75
      }
    });
    
    if(this.popup){
      this.popup.remove();
    }

    this.setState({ map: map, previousBand: nextProps.band });
    this.props.onChangePosition(
      [0, 0], 0, 0
    );
  }
  
  showPopup = (e, map) => {
    let lat = e.lngLat.lat
    let lng = e.lngLat.lng
    let B = lng - this.satelliteLng
    let l = ((this.r_e / this.pow(1 - this.pow(this.e_e, 2) * this.pow(this.sin(lat * this.PI / 180), 2), 1 / 2)) + this.altitude) * this.cos(lat * this.PI / 180)
    let z = (((this.r_e * (1 - this.pow(this.e_e, 2))) / this.pow(1 - this.pow(this.e_e, 2) * this.pow(this.sin(lat * this.PI / 180), 2), 1 / 2)) + this.altitude) * this.sin(lat * this.PI / 180)
    let ps_E = this.atan(z / l) * 180 / this.PI
    let R = this.sqrt(this.pow(l, 2) + this.pow(z, 2))
    let determine = this.sqrt(this.pow(R, 2) + this.pow(this.r_s, 2) - 2 * R * this.r_s * this.cos(ps_E * this.PI / 180) * this.cos(B * this.PI / 180))
    let elevationAngle = this.acos(((this.r_e + this.hgso) / determine) * this.sqrt(1 - this.pow((this.cos(B * this.PI / 180)), 2) * this.pow((this.cos(lat * this.PI / 180)), 2))) * 180 / this.PI
    let beta = this.acos(this.cos(B * this.PI / 180) * this.cos(lat * this.PI / 180)) * 180 / this.PI
    let A_i = this.asin(this.sin(this.abs(B) * this.PI / 180) / this.sin(beta * this.PI / 180)) * 180 / this.PI
    let azimuthAngle = null;
    if (B >= 0) {
      azimuthAngle = (lat >= 0 ? this.e_e + 180 : 360 - this.e_e);
    } else {
      azimuthAngle = (lat >= 0 ? 180 - A_i : A_i);
    }
    this.props.onChangePosition(
      [lng, lat], elevationAngle, azimuthAngle
    );
    
    if (map.getLayer('satelliteLine')){
      map.removeLayer('satelliteLine')
      map.removeSource('satelliteLine')
    }

    map.addLayer({
      "id": "satelliteLine",
      "type": "line",
      "source": {
        "type": "geojson",
        "data": {
          "type": "Feature",
          "properties": {},
          "geometry": {
            "type": "LineString",
            "coordinates": [
              [119.1, 0],
              [lng, lat]
            ]
          }
        }
      },
      "layout": {
        "line-join": "round",
        "line-cap": "round"
      },
      "paint": {
        "line-color": "red",
        "line-width": 4
      }
    });

    this.popup = new mapboxgl.Popup()
      .setLngLat(e.lngLat)
      .setHTML(
        `
          <div class="mapbox-popup-header">
            <b>Reception details</b>
          </div>
          <div class="mapboxgl-popup-body">
            <b>Elevation angle</b>: ${elevationAngle.toFixed(2)}°<br>
            <b>Azimuth angle:</b> ${azimuthAngle.toFixed(2)}°<br>
          </div>
        `
      )
      .addTo(map);
  }

  componentDidMount() {
    var map = new mapboxgl.Map({
      container: 'map',
      style: 'mapbox://styles/mapbox/streets-v9',
      center: [90.399452, 23.777176],
      zoom: 2
    });

    let img = new Image(120, 60)
    img.src = satelliteBase64
    img.onload = () => {
      map.addImage('satellite', img);
    }
    map.on('load', function () {
      map.addLayer({
        "id": "equatorial-orbit",
        "type": "line",
        "source": {
          "type": "geojson",
          "data": {
            "type": "Feature",
            "properties": {},
            "geometry": {
              "type": "LineString",
              "coordinates": [
                [0, 0],
                [360, 0]
              ]
            }
          }
        },
        "layout": {
          "line-join": "round",
          "line-cap": "round"
        },
        "paint": {
          "line-color": "black",
          "line-width": 1,
          'line-dasharray': [4, 5]
        }
      })
      map.addLayer({
        "id": "points",
        "type": "symbol",
        "source": {
          "type": "geojson",
          "data": {
            "type": "FeatureCollection",
            "features": [{
              "type": "Feature",
              "geometry": {
                "type": "Point",
                "coordinates": [119.1, 0]
              }
            }]
          }
        },
        "layout": {
          "icon-image": "satellite",
          "icon-size": 0.75
        }
      });
    });

    this.setState({ map });

    // C popup events
    map.on('click', 'ku-c-fill9', (e) => this.showPopup(e, map));
    map.on('click', 'ku-c-fill1', (e) => this.showPopup(e, map));


    // India popup events
    map.on('click', 'ku-india-fill5', (e) => this.showPopup(e, map));

    // Indonesia popup event
    map.on('click', 'ku-indo-fill4', (e) => this.showPopup(e, map));
    map.on('click', 'ku-indo-fill1', (e) => this.showPopup(e, map));

    // Philippines popup events
    map.on('click', 'ku-ph-fill3', (e) => this.showPopup(e, map));

    //BD popup events
    map.on('click', 'ku-bd-fill3', (e) => this.showPopup(e, map));

  }

  render() {
    return (
      <div>
        <div id="map" className="mapbox-css"></div>
      </div>
    );
  }
};

export default Map;